import ContentSectionImplementation from '../implementation/sections/ContentSection';
import { ComponentProps } from '@components/strapi/DynamicZoneComponent';
import {
  StrapiContentSectionDTO,
  ContentSectionDTO,
} from '@lib/strapi/dtos/components/sections/contentSection.dto';

const ContentSection = (props: ComponentProps<ContentSectionDTO>) => {
  return <ContentSectionImplementation {...props}></ContentSectionImplementation>;
};

export default ContentSection;
